<script>
export default [
  { paymentMethod: "Credit Card (MYR)", paymentId: 2, remittancePercent: 1.65 },
  { paymentMethod: "Maybank2U", paymentId: 6, remittanceAmount: 0.7 },
  { paymentMethod: "Alliance Online", paymentId: 8, remittanceAmount: 0.7 },
  { paymentMethod: "AmOnline", paymentId: 10, remittanceAmount: 0.7 },
  { paymentMethod: "RHB Online", paymentId: 14, remittanceAmount: 0.7 },
  { paymentMethod: "Hong Leong Online", paymentId: 15, remittanceAmount: 0.7 },
  { paymentMethod: "CIMB Click", paymentId: 20, remittanceAmount: 0.7 },
  { paymentMethod: "Web Cash", paymentId: 22, remittanceAmount: 0.7 },
  { paymentMethod: "Public Bank Online", paymentId: 31, remittanceAmount: 0.7 },
  { paymentMethod: "FPX TPA", paymentId: 16, remittanceAmount: 0.7 },
  { paymentMethod: "China UnionPay Online Banking", paymentId: 18, remittanceAmount: 0.7 },
  { paymentMethod: "PayPal (MYR)", paymentId: 48, remittanceAmount: 0.7 },
  { paymentMethod: "Credit Card (MYR) Pre-Auth", paymentId: 55, remittanceAmount: 0.7 },
  { paymentMethod: "Bank Rakyat Internet Banking", paymentId: 102, remittanceAmount: 0.7 },
  { paymentMethod: "Affin Online", paymentId: 103, remittanceAmount: 0.7 },
  { paymentMethod: "Pay4Me (Delay payment)", paymentId: 122, remittanceAmount: 0.7 },
  { paymentMethod: "BSN Online", paymentId: 124, remittanceAmount: 0.7 },
  { paymentMethod: "Bank Islam", paymentId: 134, remittanceAmount: 0.7 },
  { paymentMethod: "UOB", paymentId: 152, remittanceAmount: 0.7 },
  { paymentMethod: "Hong Leong PEx+ (QR Payment)", paymentId: 163, remittanceAmount: 0.7 },
  { paymentMethod: "Bank Muamalat", paymentId: 166, remittanceAmount: 0.7 },
  { paymentMethod: "OCBC", paymentId: 167, remittanceAmount: 0.7 },
  { paymentMethod: "Standard Chartered Bank", paymentId: 168, remittanceAmount: 0.7 },
  { paymentMethod: "CIMB Virtual Account (Delay payment)", paymentId: 173, remittanceAmount: 0.7 },
  { paymentMethod: "Maybank2E", paymentId: 178, remittanceAmount: 0.7 },
  { paymentMethod: "HSBC Online Banking", paymentId: 198, remittanceAmount: 0.7 },
  { paymentMethod: "Kuwait Finance House", paymentId: 199, remittanceAmount: 0.7 },
  { paymentMethod: "FPX_Agro", paymentId: 405, remittanceAmount: 0.7 },
  { paymentMethod: "Bank of China", paymentId: 1261, remittanceAmount: 0.7 },

  { paymentMethod: "Boost Wallet", paymentId: 210, remittanceList: { 0 : {remittancePercent: 0}, [moment('2020-02-03').unix()]: {remittancePercent: 1} } },
  // { paymentMethod: "Boost Wallet", paymentId: 210, remittanceList: { 0 : {remittancePercent: 0}, [moment('2020-02-03').unix()]: {remittancePercent: 1}, [moment('2020-06-01').unix()]: {remittancePercent: 0.8} }, },
  { paymentMethod: "GrabPay", paymentId: 523, remittanceList: { 0 : {remittancePercent: 1}, [moment('2024-08-12').unix()]: {remittancePercent: 1.2} } },
  { paymentMethod: "VCash", paymentId: 243, remittancePercent: 1 },
  { paymentMethod: "Gpay", paymentId: 518, remittancePercent: 1.65 },
  { paymentMethod: "MBBQR", paymentId: 542, remittanceAmount: 0.08 },
  // { paymentMethod: "MBBQR", paymentId: 542, remittanceList: { 0 : {remittanceAmount: 0.08}, [moment('2020-06-01').unix()]: {remittancePercent: 1} } },
  { paymentMethod: "TnG ewallet", paymentId: 538, remittanceList: { 0 : {remittancePercent: 1}, [moment('2024-08-12').unix()]: {remittancePercent: 1.1} } },
  { paymentMethod: "Mcash", paymentId: 244, remittancePercent: 1 },
  { paymentMethod: "Shopeepay", paymentId: 801, remittancePercent: 1 },
  
  { paymentMethod: "FPX_B2B_UOB", paymentId: 270, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_BRakyat", paymentId: 271, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_ALB", paymentId: 272, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_Affin", paymentId: 273, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_CIMB", paymentId: 274, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_BIMB", paymentId: 275, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_M2U", paymentId: 276, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_Ambank", paymentId: 277, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_HLB", paymentId: 278, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_PBB", paymentId: 279, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_RHB", paymentId: 280, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_Muamalat", paymentId: 281, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_HSBC", paymentId: 282, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_KFH", paymentId: 283, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_OCBC", paymentId: 285, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_SCB", paymentId: 286, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_PBEnterprise", paymentId: 400, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_Citibank", paymentId: 399, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_Deutsche", paymentId: 402, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_UOBRegional", paymentId: 401, remittanceAmount: 1.2 },
  { paymentMethod: "FPX_B2B_AffinMax", paymentId: 407, remittanceAmount: 1.2 },
]

</script>


// WEBPACK FOOTER //
// src/components/Param/iPayPaymentCode.vue